module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Menu Node Widget */

(function(fox) {

	var _options = {
			alias: {
				mandatory: true
			},
			tpl: [{
				row: {
					'default': 'p{$[title]}'
				}
			}]
		};

	fox.registerWidget('Site_Menu', {

		//Widget config
		configure: function(options) {
			this.prepareOptions(options, _options);
			options.dataLayer || (options.dataLayer = this.initDl(options.alias));
			this.callParent('configure', arguments);
		},

		// initDl: function(alias) {
		// 	var dl = fox.createDataLayer().setClass('Site_Menu').setFields(['id', 'title', 'alias', 'link']);
		// 	if (!fox.isEmpty(fox.site.member)) {
		// 		return dl.addFilter(['treeId.alias'], [alias]).addFilter(['access'], [[1,3]]).addSorting('position');
		// 	} else {
		// 		return dl.addFilter(['treeId.alias'], [alias]).addFilter(['access'], [[2,3]]).addSorting('position');
		// 	}

		// },

		// running: function() {
		// 	this.dl.load();
		// },

		render: function() {
			return;
		}

	}, 'Grid_List');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/site/menu.js
// module id = 1255
// module chunks = 4